var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$attrs.class, 'h-32px text-lighter-grey-4 hover:bg-white px-16px py-6px leading-5 w-full']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }